import { render, staticRenderFns } from "./circ.vue?vue&type=template&id=2c6e40ab&scoped=true"
import script from "./circ.vue?vue&type=script&lang=js"
export * from "./circ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e40ab",
  null
  
)

export default component.exports